import React, { useMemo } from "react";
import { getPredictionWidth } from "../../../utils/generalLiveCenter";


const PredictionBox = ({
  title,
  drawLable = false,
  t1Score,
  t2Score,
  t1P,
  t2P,
  drawScore,
  drawP,
}) => {
  const { t1W, t2W, drawW } = useMemo(
    () => getPredictionWidth(t1P, t2P, drawLable, drawP),
    [t1P, t2P, drawLable, drawP]
  );
  const formatPercentage = (value) => {
    if (!value && value !== 0) return "0%";
    const stringValue = String(value);
    return stringValue.includes("%") ? stringValue : `${stringValue}%`;
  };

  return (
    <div className="prediction">
      <div className="leg_head">
        <h2>{title}</h2>
      </div>
      <div className={`predict_box`}>
        <div className="predict_head">
          <strong className="pre_col">Home</strong>
          {drawLable ? <strong className="pre_col">Draw</strong> : null}
          <strong className="pre_col right">Away</strong>
        </div>
        <div className="predict_body">
          {/* Score row */}
          <div className="bar-labels">
            <span className="label-left">{t1Score}</span>
            {drawLable && <span className="label-center">{drawScore}</span>}
            <span className="label-right">{t2Score}</span>
          </div>

          {/* Continuous bar */}
          <div className="continuous-bar">
            <span className="bar-segment left" style={{ width: t1W }} />
            {drawLable && <span className="bar-segment center" style={{ width: drawW }} />}
            <span className="bar-segment right" style={{ width: t2W }} />
          </div>

          {/* Percentage row */}
          <div className="bar-labels">
            <span className="label-left">{formatPercentage(t1W)}</span>
            {drawLable && <span className="label-center">{formatPercentage(drawW)}</span>}
            <span className="label-right">{formatPercentage(t2W)}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PredictionBox;
